import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASE_URL } from '../../config/env';

export const geojsonApi = createApi({
  reducerPath: 'GeojsonApi',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = getState()?.auth?.token;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (build) => ({
    getStatesGeoJson: build.query({
      query: ({ state_id, crop_id }) => ({
        url: `crop-location/state-geo-json`,
        method: 'GET',
        params: { state_id, crop_id },
      }),
    }),
    getGeoJson: build.query({
      query: ({ state_id, district_id, crop_id, infestation_id }) => ({
        url: `crop-location/geo-json`,
        method: 'GET',
        params: { state_id, district_id, crop_id, infestation_id },
      }),
    }),
    getSubDistrictsGeoJson: build.query({
      query: ({
        state_id,
        district_id,
        sub_district_id,
        crop_id,
        infestation_id,
      }) => ({
        url: `crop-location/sub-dist-geo-json`,
        method: 'GET',
        params: {
          state_id,
          district_id,
          sub_district_id,
          crop_id,
          infestation_id,
        },
      }),
    }),
  }),
});

export const {
  useGetStatesGeoJsonQuery,
  useGetGeoJsonQuery,
  useGetSubDistrictsGeoJsonQuery,
} = geojsonApi;
